import { List } from "antd";
import React from "react";
import "./index.less";
import { useTranslate } from "@obsbot/remo-i18n";
interface UpdateRecordProps {
    recordList: RecordItem[];
    showDot?: boolean;
}
export interface RecordItem {
    version: string;
    update_time: string;
    content: any[];
}

export const UpdateRecord: React.FC<UpdateRecordProps> = ({ recordList, showDot = true }) => {
    const t = useTranslate();

    return (
        <div className="update-version-record">
            {recordList.map(item => {
                return (
                    <div key={item.version} className="version-item">
                        {item.update_time && (
                            <div className="version-item-title">
                                {`${item.update_time} ${t("settings.software-version.title")} (${item.version})`}
                            </div>
                        )}
                        <div className="version-item-content">
                            <List
                                dataSource={item.content}
                                renderItem={content => (
                                    <List.Item
                                        className={
                                            showDot
                                                ? "version-item-desc-dot"
                                                : "version-item-desc-no-dot"
                                        }
                                    >
                                        <div className="version-item-desc">{content}</div>
                                    </List.Item>
                                )}
                            />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
